import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/SayTS/auth.service';
import { Router } from '@angular/router';
import { Fce } from 'src/app/SayTS/fce';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  credentials = {
    username: '',
    password: '',
    rememberMe: false
  };

  constructor(
    protected authService: AuthService,
    protected shared: SharedService,
    protected router: Router
  ) { }

  ngOnInit() {
    if (this.shared.isLoggedIn())
      this.loginSuccess();
  }

  async loginPass() {
    await this.authService.loginUser(this.credentials);
    if (this.shared.isLoggedIn()) {
      this.loginSuccess();
    }
  }

  loginSuccess() {
    const excluded = ['/login', '/register'];
    if (Fce.empty(this.shared.getAny("last_wanted_url")) || excluded.includes(this.shared.getAny("last_wanted_url")))
      this.router.navigate(['/dashboard']);
    else {
      this.router.navigate([this.shared.getAny("last_wanted_url")]);
      this.shared.setAny("last_wanted_url", null);
    }
  }
}
